import * as z from "zod";

export const getGorgiasConnectionStatus = {
  name: "getGorgiasConnectionStatus" as const,
  input: z.null(),
  output: z.object({
    connected: z.boolean(),
    account: z.nullable(z.string()),
    hasEscalationScope: z.boolean(),
    smsPhoneNumber: z.nullable(z.string()),
    smsEscalationEnabled: z.boolean(),
    needsEscalationReauth: z.boolean(),
  }),
};
